import * as Vue from "vue";

export const eventBus = new Vue();

export const signalNames = {
  changeSidebarStatus: "changeSS_signal",
  setTitle: "set_title",
  setToolbarOptions: "set_toolbar_options",
  showError: "show_error"
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/bus.ts